import 'plyr/dist/plyr.css';
import Plyr from 'plyr';

export default {
    players: [],
    init() {
        this.players = Array.from(document.querySelectorAll('.js-player')).map((p) => new Plyr(p));
    },
};
